import React, { useState, useEffect } from 'react';
import mapboxgl from 'mapbox-gl';

mapboxgl.accessToken = 'pk.eyJ1IjoibWljaGFlbC1qYWNvdCIsImEiOiJjbThkY2lmOGQwbWZoMmpvZ2Z1M2xsYTRsIn0.WZPUkFIAIenQhNTTPbVVuQ';

function ShipLocation() {
  const [map, setMap] = useState(null);
  const [mapStyleLoaded, setMapStyleLoaded] = useState(false);

  // Define latitude and longitude from URL parameters
  const latitude = parseFloat(new URLSearchParams(window.location.search).get('lat'));
  const longitude = parseFloat(new URLSearchParams(window.location.search).get('lon'));

  useEffect(() => {
    // Create a new map after the component has mounted
    const mapInstance = new mapboxgl.Map({
      container: 'map', // Container ID
      style: 'mapbox://styles/mapbox/streets-v11', // Default Mapbox style
      center: [longitude, latitude], // Use the latitude and longitude from URL parameters
      zoom: 10, // Adjust the zoom level as needed
    });

    mapInstance.on('style.error', (error) => {
      console.error('Error loading Mapbox style:', error);
    });

    mapInstance.addControl(new mapboxgl.NavigationControl()); // Add zoom controls
    mapInstance.on('style.load', () => {
      console.log('Map style has loaded.');

      setMap(mapInstance);
      // Set the map style as loaded
      setMapStyleLoaded(true);
    });

    // Use a custom ship marker
    const shipMarker = document.createElement('div');
    shipMarker.className = 'mapboxgl-marker';
    shipMarker.style.backgroundImage = 'url(https://cdn.iconscout.com/icon/premium/png-512-thumb/navigation-pin-5848273-4910997.png?f=webp&w=256)'; // Replace with your ship icon URL
    shipMarker.style.backgroundSize = 'contain';
    shipMarker.style.width = '40px'; // Adjust marker width as needed
    shipMarker.style.height = '40px'; // Adjust marker height as needed

    // Add the custom ship marker to the map
    new mapboxgl.Marker(shipMarker).setLngLat([longitude, latitude]).addTo(mapInstance);

    // Clean up the map when the component unmounts
    return () => {
      if (mapInstance) {
        mapInstance.remove();
      }
    };
  }, []); // Empty dependency array to run the effect only once

  useEffect(() => {
    // Check if the map style has loaded before making any map-related operations
    if (mapStyleLoaded) {
      console.log('Map style is loaded. Adding ship layers...');
      // You can add sources, layers, or any other map-related operations here
    }
  }, [mapStyleLoaded]);

  return <div id="map" style={{ width: '100%', height: '100vh' }} />;
}

export default ShipLocation;
